/**
 * Loads gtag.js on the first user interaction. See gatsby-ssr.js.
 */
const ORIGIN = 'https://www.googletagmanager.com';
const INTERACTION_EVENTS = ['click', 'scroll', 'mousemove', 'touchstart', 'keydown'];
// Visitors who never interact still get counted: once the page has loaded and
// the browser is idle, fetch the library anyway. The tag's main-thread work is
// small (about 90ms, 5ms of it blocking), so this costs the audit little,
// unlike the 220ms Facebook SDK, which keeps its 30s fallback.
const IDLE_TIMEOUT_MS = 2000;

let loaded = false;

const loadGtag = () => {
    if (loaded || typeof window === 'undefined') return;
    loaded = true;
    INTERACTION_EVENTS.forEach((event) => window.removeEventListener(event, loadGtag));
    const ids = window.__GTAG_IDS__ || [];
    if (ids.length === 0) return;
    const script = document.createElement('script');
    script.async = true;
    script.src = `${ORIGIN}/gtag/js?id=${encodeURIComponent(ids[0])}`;
    document.head.appendChild(script);
};

const loadWhenIdle = () => {
    if ('requestIdleCallback' in window)
        window.requestIdleCallback(loadGtag, { timeout: IDLE_TIMEOUT_MS });
    else setTimeout(loadGtag, IDLE_TIMEOUT_MS);
};

exports.onClientEntry = () => {
    if (typeof window === 'undefined' || process.env.NODE_ENV !== 'production') return;
    INTERACTION_EVENTS.forEach((event) =>
        window.addEventListener(event, loadGtag, { once: true, passive: true })
    );
    if (document.readyState === 'complete') loadWhenIdle();
    else window.addEventListener('load', loadWhenIdle, { once: true });
};

// Queued through the stub until gtag.js arrives, then processed in order.
exports.onRouteUpdate = ({ location }) => {
    if (typeof window === 'undefined' || process.env.NODE_ENV !== 'production') return;
    if (typeof window.gtag !== 'function') return;
    const sendPageView = () =>
        window.gtag('event', 'page_view', {
            page_path: location ? location.pathname + location.search + location.hash : undefined,
        });
    // Two frames later, so document.title reflects the new page (as upstream).
    if ('requestAnimationFrame' in window)
        requestAnimationFrame(() => requestAnimationFrame(() => setTimeout(sendPageView, 0)));
    else setTimeout(sendPageView, 32);
};
